var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/view/dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/view/dark",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9325111,10.4995414 C19.129562,12.0907067 17.9139934,13.4379085 16.4266316,14.4009572 C14.8637544,15.4129011 13.0004057,16 11,16 C8.99982593,16 7.136678,15.4130374 5.57385948,14.4013839 C4.08633298,13.4384689 2.87054886,12.0914264 2.06748895,10.5004586 C2.87043798,8.90929331 4.08600659,7.56209149 5.57336844,6.5990428 C7.13624562,5.58709886 8.99959426,5 11,5 C13.0001741,5 14.863322,5.5869626 16.4261405,6.5986161 C17.913667,7.5615311 19.1294511,8.9085736 19.9325111,10.4995414 Z",
    id: "Combined-Shape",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,7 C11.3080713,7 11.6052969,7.04643625 11.8850591,7.13269114 C11.3628585,7.36686482 11,7.89105733 11,8.5 C11,9.32842712 11.6715729,10 12.5,10 C13.1089427,10 13.6331352,9.63714147 13.8681515,9.11585043 C13.9535638,9.39470309 14,9.69192866 14,10 C14,11.6568542 12.6568542,13 11,13 C9.34314575,13 8,11.6568542 8,10 C8,8.34314575 9.34314575,7 11,7 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.d32839465a6651d2fc3c09f94a67d412.svg";
export { ForwardRef as ReactComponent };